export function LogoIcon(props: { size?: number }) {
  const size = props.size || 24

  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 80 80'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M52.705 72.07H26.415C23.125 72.07 20.045 70.29 18.385 67.43L5.245 44.67C3.585 41.81 3.585 38.26 5.245 35.4L18.385 12.64C20.035 9.78 23.115 8 26.415 8H56.045L45.215 26.52H33.095C32.265 26.52 31.495 26.96 31.085 27.68L24.615 38.88C24.205 39.59 24.205 40.48 24.615 41.2L31.085 52.4C31.495 53.11 32.265 53.56 33.095 53.56H45.225L55.855 72.07H52.705ZM26.415 11C24.185 11 22.105 12.2 20.985 14.14L7.845 36.9C6.725 38.83 6.725 41.24 7.845 43.17L20.985 65.93C22.105 67.87 24.185 69.07 26.415 69.07H50.715L43.495 56.56H33.095C31.195 56.56 29.435 55.54 28.485 53.9L22.015 42.7C21.065 41.06 21.065 39.02 22.015 37.38L28.485 26.18C29.435 24.54 31.195 23.52 33.095 23.52H43.475L50.695 11H26.405H26.415Z'
        fill='#BEBEBE'
      />
      <path
        d='M58.9151 69.9894L48.4651 51.6994L54.5151 41.2094C54.9251 40.4894 54.9251 39.6094 54.5151 38.8894L48.4551 28.3894L59.1451 9.85938L60.7351 12.6294L73.9151 35.4594C75.5451 38.2794 75.5451 41.8294 73.8951 44.6894L67.1451 56.3794L58.9351 69.9794L58.9151 69.9894ZM51.9251 51.6994L59.1451 64.2194L71.2851 43.1894C72.4051 41.2594 72.4051 38.8494 71.2851 36.9194V36.8994L59.1351 15.8694L51.9151 28.3894L57.1151 37.3894C58.0651 39.0294 58.0651 41.0694 57.1151 42.7094L51.9251 51.6994Z'
        fill='#BEBEBE'
      />
    </svg>
  )
}
